<div style="font-weight: bold;font-size: 20px;">
<p *ngIf="isExternalRole" style="letter-spacing: 0cm">
  <b
    >Please ensure documents being submitted are clear and visible, any document
    that is not clear and visible will be rejected.</b
  >
</p>
<br />
<p *ngIf="isExternalRole">
  <b
    >All foreign documents must be translated by a certified translator in
    English</b
  >
</p>
</div>
<br />
<ng-container *ngFor="let docType of DocTypesList; let i = index">
  <h1>
    <b style="font-size: 30px;"
      >{{ docType.description }}
      <a class="red-asterik" *ngIf="docType.is_mandatory">*</a></b
    >
  </h1>
  <input
    type="hidden"
    value="{{ docType.description }}"
    id="fileupload-{{ i }}-desc"
    name="fileupload-{{ i }}-desc"
  />
  <br />
  <label
    *ngIf="isKiosk == false && isExternalRole"
    class="center"
    fileDragDrop
    (filesChangeEmiter)="onFileChange($event, docType.document_type_id)"
  >
    <input
      class="file-upload"
      style="display: none"
      onclick="this.value=''"
      id="fileupload-{{ i }}"
      #fileupload
      type="file"
      (change)="onFileSelected($event, docType.document_type_id)"
    />
    <img src="../../assets/img/vector-51@2x.png" height="18"  /> <br /><p style="font-size: 16px;">Drag and
    drop files here or search on your computer </p>
    <span style="text-decoration: underline; color: #274c9c;font-size: 16px;">Upload file <br /></span>
  </label>
  <label *ngIf="isKiosk == true && isExternalRole" class="center">
    <input
      class="file-upload"
      style="display: none"
      onclick="this.value=''"
      id="fileupload-{{ i }}"
      #fileupload
      type="file"
      (click)="scanDocument(docType.document_type_id)"
      title="Scan"
    />
    <img src="../../assets/img/vector-51@2x.png" height="18" style="font-size: 16px;" /> <br /><p  style="font-size: 16px;">Drag and
    drop files here or search on your computer</p><br />
    <span style="text-decoration: underline; color: #274c9c">Scan</span>
  </label>
  <span *ngIf="isExternalRole" style="font-size: 16px"
    >Max file size {{ maxMB }}MB {{ dtype }} format</span
  >
  <div class="card">
    <h2 class="card-title">Files Uploaded</h2>
    <div *ngFor="let UserDocument of UserDocuments">
      <div *ngIf="UserDocument.document_type_id == docType.document_type_id">
        <div class="card-body">
          <!-- <h2>Files Uploaded(0)</h2> -->

          <div class="row">
            <div
              class="col-sm bg-light desc"
              style="color: #020202; font-size: 15px; font-family: 'Open Sans'; font-style: normal; font-weight: 400;line-height: 22px;"
            >
              <br />
              {{ UserDocument.file_name }}
            </div>
            <div class="col-sm bg-light">
              <br />
              <p
                style="
                  color: #020202;
                  text-align: center;
                  font-family: 'Open Sans';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 15px;
                  line-height: 27px;
                "
              >
                PDF
              </p>
            </div>
            <div
              class="col-sm bg-light"
              style="color: #020202; font-size: 15px; font-family: 'Open Sans'; font-style: normal; font-weight: 400;line-height: 22px"
            >
              <br />
              {{ UserDocument.date_created | date : "dd/MM/yyyy h:mm:ss a" }}
              <span style="float: right !important">
                <span
                  title="iCBMS Document Viewer"
                  class="btn btn-sm"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  (click)="
                    viewDoc(
                      UserDocument.document_type_id,
                      UserDocument.document_link
                    )
                  "
                >
                  <img src="../../assets/newimg/visibility-16@2x.png" />
                </span>
                <span
                  *ngIf="isExternalRole"
                  title="Delete Document"
                  class="btn btn-sm"
                  (click)="onConfirm(UserDocument)"
                  ><img src="../../assets/newimg/delete@1x.png"
                /></span>
                <!-- <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                        class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- <br>   <br>
    <h2>Files Uploaded({{UserDocuments.length}})</h2> -->

<div class="col-md-12" *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>
<button
  id="btnView"
  class="btn btn-primary"
  style="width: 0px; visibility: hidden"
  aria-hidden="true"
  data-toggle="modal"
  data-target="#exampleModalLong"
></button>

<div>
  <!-- <label><strong>Document Uploads</strong><span class="txt-max"> Max file size {{maxMB}}MB {{dtype}}</span></label> -->
  <div>
    <!--<div *ngIf="isRemove" class="text-danger col-md-12">
        <input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
        <button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
        <button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
      </div>-->
    <div class="col-md-12" *ngIf="!isRemove">
      <!-- <div class="warnig-text" *ngIf="DocTypesList.length > 0 || UserDocuments.length>0">
                    When submitting copies of letters, documents or contracts in support of an application, please ensure that they are clear and legible. Documents that are not clear will not be accepted as supporting evidence. All foreign documents must be translated by
                    a certified translator into English.
                </div> -->
      <table id="vTypes" class="tbl">
        <!-- <thead class="thead-inverse hgt-btn">
            <tr style="vertical-align:middle;margin:0px;padding:0px;"  class="hgt-btn">
              <th>
                Document Type
              </th>
              <th style="vertical-align:middle;">
                File Name
              </th>              
            </tr>
          </thead> -->

        <!-- <tr class="separator" *ngFor="let UserDocument of UserDocuments   | paginate: { itemsPerPage: 5, currentPage: page }">
                        <span class="tbl-td">{{UserDocument.description}} - {{UserDocument.file_name}}</span>
                        <td>
                            <span title="Delete Document" class="btn btn-danger btn-sm" (click)="onConfirm(UserDocument)"><i 
                    class="fa fa-trash-o fa-fw"></i></span>
                            <span title="iCBMS Document Viewer" class="btn btn-success btn-sm"><i
                    class="fa fa-eye" aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong" (click)="viewDoc(UserDocument.document_link)"></i></span>
                            <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true"  class="btn btn-primary btn-sm"><i
                    class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span>
                        </td>
                    </tr> -->

        <tfoot>
          <!-- <ng-container *ngFor="let docType of DocTypesList; let i=index;">
                            <tr *ngIf="docType.is_mandatory">
                                <td> <span class="tbl-td">{{docType.description}}
                  <input  type="hidden" value="{{docType.description}}" id="fileupload-{{i}}-desc" name="fileupload-{{i}}-desc">
                  <a class="red-asterik">*</a></span> </td>
                                <td class="bdr"></td>
                              
                                <td style="padding-top: 7px; padding-left: 5px">
                                    <label class="btn fileUpload btn-default" *ngIf="isKiosk == false" style="border-radius: 4px; width: 120px; height: 40px; background-color:#1d3f94; color:white;">Choose File
                    <input class="file-upload" style="display:none" onclick="this.value=''" id="fileupload-{{i}}" #fileupload type="file" (change)="onFileSelected($event,docType.document_type_id)" />

                    
                  </label>
                                    <button *ngIf="isKiosk == true" class="btn fileUpload btn-default btn btn-md m-clr hd-btn" (click)="scanDocument(docType.document_type_id)" title="Scan">Scan</button>
                                </td>
                            </tr>
                        </ng-container> -->
          <!-- OR -->
          <!-- <ng-container *ngFor="let docType of DocTypesList">
                            <tr *ngIf="!docType.is_mandatory">
                                <td> <span class="tbl-td">{{docType.description}}</span> </td>
                                <td class="bdr"></td>
                                
                                <td style="padding-top: 7px; padding-left: 5px">
                                    <label class="btn fileUpload btn-default" *ngIf="isKiosk == false" style="border-radius: 4px; width: 120px; height: 40px; background-color:#1d3f94; color:white;">Choose File
                    <input  style="display:none" onclick="this.value=''" id="fileupload" #fileupload type="file" (change)="onFileSelected($event,docType.document_type_id)" />
                  </label>
                                    <button *ngIf="isKiosk == true" class="btn fileUpload btn-default btn btn-md m-clr hd-btn" (click)="scanDocument(docType.document_type_id)" title="Scan">Scan</button>
                                </td>
                            </tr>
                        </ng-container> -->

          <!-- <tr *ngIf="UserDocuments.length > 4">
                            <td colspan="4" class="rm-brd">
                                <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
                            </td>
                        </tr> -->

          <!-- <tr *ngIf="isEmpty">
                            <td colspan="4" class="rm-brd">
                                <span class="text-info text-small">(No Documents found)</span>
                            </td>
                        </tr> -->
        </tfoot>
      </table>
    </div>
  </div>
</div>

<!-- <div class="card">
    <h2 class="card-title">Files Uploaded({{UserDocuments.length}})</h2>

    <div class="card-body" *ngFor="let UserDocument of UserDocuments   | paginate: { itemsPerPage: 5, currentPage: page }">

        <div class="row">
            <div class="col-sm bg-light">
                {{UserDocument.description}}
            </div>
            <div class="col-sm bg-light">
                PDF
            </div>
            <div class="col-sm bg-light">
                4.3M <span style="float: right !important;"> <span title="Delete Document" class="btn btn-danger btn-sm" (click)="onConfirm(UserDocument)"><i class="fa fa-trash-o fa-fw"></i></span> <span title="iCBMS Document Viewer" class="btn btn-success btn-sm"><i
                class="fa fa-eye" aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong" (click)="viewDoc(UserDocument.document_type_id,UserDocument.document_link)"></i></span>
                <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span></span>
            </div>
        </div>





    </div>
    <div *ngIf="UserDocuments.length > 4">
        <div colspan="4" class="rm-brd">
            <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
        </div>
    </div>
</div> -->

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModalLong"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Document Upload</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px" *ngIf="!isPromptUserToScan">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <!-- <ng2-pdfjs-viewer     *ngIf="pdfSrc" [pdfSrc]='pdfSrc'         
            id='view2'             
          [externalWindow]="false"
          [downloadFileName]="'mytestfile.pdf'"                  
          [openFile]="false"
          [viewBookmark]="false"
          [download]="false" >
        </ng2-pdfjs-viewer> -->
          <img [src]="img" *ngIf="img" />
          <ngx-loading [show]="isLoadingImg"></ngx-loading>
        </div>

        <div
          style="width: 99%; min-height: 470px"
          class="text-center"
          *ngIf="isPromptUserToScan"
        >
          <img src="/assets/Photocopy.gif" class="text-center" />
          <p>{{ scannerMessage }}</p>
        </div>
      </div>
      <div class="modal-footer">
        <div *ngIf="!isPromptUserToScan && isKiosk">
          <button
            type="button"
            *ngIf="!isViewMode"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            (click)="callTheScanner()"
          >
            Rescan
          </button>
          <button
            type="button"
            *ngIf="!isViewMode"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            (click)="postScannedDoc()"
          >
            Accept
          </button>
        </div>
        <div *ngIf="isPromptUserToScan">
          <button
            type="button"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton"
            (click)="callTheScanner()"
          >
            Scan
          </button>
        </div>
        <button
          type="button"
          class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton"
          (click)="cancelScanner()"
          data-dismiss="modal"
        >
          Close
        </button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>

  <!-- <div class="modal-dialog modal-lg" tabindex="-1" aria-hidden="true" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Document Uploaded</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-lg">

                <img *ngIf="isPDF==2" [src]="doc" width="780" />
                <pdf-viewer *ngIf="isPDF==1" [src]="doc" [render-text]="true" style="display: block;" [original-size]="false" [autoresize]="true"></pdf-viewer>
                <ngx-loading [show]="isLoadingImg"></ngx-loading>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button>
                 <button type="button" class="btn btn-primary">Save changes</button> 
</div>
</div>
</div> -->
</div>
